module.exports = __webpack_public_path__ + "static/85d5197bfaab89be4f32737326589dc2e3f27f7e7bf08ecd742553e08e306712-77ab7685e2260bb85338f582a2c89ef5.png";